<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="providerIdLocale"
          dense
          outlined
          label="Provider Id"
          item-text="nome"
          item-value="id"
          validate-on-blur
          :loading="loading"
          :items="provedoresWhatsAppIds"
          :rules="[validators.select]"
          @change="v => $emit('update:providerId', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="providerAPITokenLocale"
          dense
          outlined
          label="Provider API Token"
          hint="Máximo de 800 caracteres"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 800) || 'Máximo de 800 caracteres']"
          @change="v => $emit('update:providerAPIToken', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="providerIdentifierLocale"
          dense
          outlined
          label="Provider Identifier"
          hint="Máximo de 300 caracteres"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
          @change="v => $emit('update:providerIdentifier', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-switch
          v-model="permitirAlertaTemplateLocale"
          class="mt-0"
          :label="`Alerta do envio de template: ${permitirAlertaTemplateLocale ? 'Ativo' : 'Inativo'}`"
          @change="v => $emit('update:permitirAlertaTemplate', v)"
        />
      </v-col>
    </v-row>

    <v-expand-transition>
      <v-row>
        <v-col cols="12">
          <whats-app-config-templates
            :canal-whats-app-id="canalData.id"
            @update:templates="v => $emit('update:templates', v)"
          />
        </v-col>
      </v-row>
    </v-expand-transition>
  </div>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import WhatsAppConfigTemplates from './WhatsAppConfigTemplates.vue'
import CanalWhatsAppProviderEnum from '@/models/entities/canal/CanalWhatsAppProviderEnum'

export default {
  // Adicionado 'update:templates' na lista de eventos emitidos
  emits: [
    'update:providerId',
    'update:providerAPIToken',
    'update:providerIdentifier',
    'update:permitirAlertaTemplate',
    'update:templates',
  ],

  components: {
    WhatsAppConfigTemplates,
  },

  props: {
    canalData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const providerAPITokenLocale = ref(null)
    const providerIdentifierLocale = ref(null)
    const providerIdLocale = ref(null)
    const permitirAlertaTemplateLocale = ref(null)

    // isCanalNovo mantido para lógica interna se necessário, mas não bloqueia mais a view
    const isCanalNovo = computed(() => !props.canalData.id)
    const provedoresWhatsAppIds = [CanalWhatsAppProviderEnum.Zenvia]

    watch(
      () => props.canalData,
      v => {
        providerAPITokenLocale.value = v?.providerAPIToken || null
        providerIdentifierLocale.value = v?.providerIdentifier || null
        providerIdLocale.value = v?.providerId || null
        permitirAlertaTemplateLocale.value = v?.permitirAlertaTemplate || null
      },
      { immediate: true },
    )

    return {
      providerAPITokenLocale,
      providerIdentifierLocale,
      providerIdLocale,
      permitirAlertaTemplateLocale,
      isCanalNovo,
      provedoresWhatsAppIds,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
